import React from "react";
import { Box, Fade, Grid, Typography, useTheme } from "@mui/material";
import SpecialCard from "../card/SpecialCard";

import { ReactComponent as RealignYourself } from "../../resources/images/svg/home/support/realignYourself.svg";
import { ReactComponent as Concil } from "../../resources/images/svg/home/support/council.svg";
import { ReactComponent as Communicate } from "../../resources/images/svg/home/support/communicate.svg";
import { ReactComponent as Resource } from "../../resources/images/svg/home/support/resource.svg";
import { ReactComponent as Link } from "../../resources/images/svg/home/support/link.svg";
import { ReactComponent as NetworkMap } from "../../resources/images/svg/home/support/networkMap.svg";
import useIsOnScreen from "../../hooks/useIsOnScreen";
import { useIsMobile } from "../../hooks/responsive";

const FindSupportCard = ({
  index = 0,
  icon,
  title,
  cardProps = {},
  textSx = {},
  ...props
}) => {
  const ref = React.useRef(null);
  const isVisible = useIsOnScreen(ref);
  return (
    <Grid
      ref={ref}
      xs={6}
      md={3}
      sx={{
        width: { xs: "100%", sm: "auto" },
        maxWidth: "200px",
      }}
    >
      <Fade in={isVisible} timeout={index * 500}>
        <Box sx={{ width: "100%" }}>
          <SpecialCard {...cardProps}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {icon}
              <Typography
                sx={{
                  mt: 1.5,
                  fontSize: "16.5px",
                  fontFamily: "Branding Bold",
                  fontWeight: "semibold",
                  ...textSx,
                }}
              >
                {title}
              </Typography>
            </Box>
          </SpecialCard>
        </Box>
      </Fade>
    </Grid>
  );
};

const FindSupportCards = (props) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Grid
      container
      spacing={2}
      {...props}
      sx={{
        ...props.sx,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: isMobile ? "3vw" : undefined,
        marginLeft: isMobile ? "3vw" : undefined,
      }}
    >
      <FindSupportCard
        index={0}
        icon={<RealignYourself width={"62px"} height={"62px"} />}
        title={"Conseils pour se réaligner"}
      />
      <FindSupportCard
        index={1}
        icon={<Concil width={"62px"} height={"62px"} />}
        title={"Astuces de gestion et de communication"}
      />
      <FindSupportCard
        index={2}
        icon={<Resource width={"62px"} height={"62px"} />}
        title={"Boites à outils pour praticien éclairé"}
      />
      <FindSupportCard
        index={3}
        icon={<Communicate width={"62px"} height={"62px"} />}
        title={"Idées pour se ressourcer"}
      />
      <FindSupportCard
        index={4}
        icon={<Link width={"62px"} height={"62px"} />}
        title={"Connexions professionnelles"}
      />
      <FindSupportCard
        index={5}
        icon={<NetworkMap width={"62px"} height={"62px"} />}
        title={"Accès aux partenaires clés"}
      />
    </Grid>
  );
};

export default FindSupportCards;
